import { Heading3 } from '@lightspeed/flame/Text';
import { Box, Flex } from '@lightspeed/flame/Core';
import { LabelRequired } from '../custom/LabelRequired';
import { Autocomplete } from '../fields';
import { useTranslation } from 'react-i18next';
import useAccounts from '../../hooks/useAccounts';
import useIsInputsOnlyLayout from '../../hooks/useIsInputsOnlyLayout';

export const Membership = () => {
  const [isLoading, accountsList] = useAccounts('giftCard');
  const { t } = useTranslation();
  const [isInputsOnlyLayout] = useIsInputsOnlyLayout();

  return <Box padding="0.75rem">
    <Heading3 mb="0.375rem">Membership</Heading3>
    <Flex>
      <Box width="49%" pr="1.1rem">
        <LabelRequired htmlFor="Membership">
          {
            t(isInputsOnlyLayout ? 'Enter Membership account' : 'Select a Membership account')
          } 
        </LabelRequired>
        <Autocomplete
          isLoadingOptions={isLoading}
          id="membershipAccount"
          name="membershipAccount"
          options={accountsList}
          placeholder={
            t(isInputsOnlyLayout ? 'Enter Membership account' : 'Select an account')
          }
        />
      </Box>
    </Flex>
  </Box>;
};
